
define('eteration/ui/wingo-viewmodel',[ 'jquery', 'knockout', 'moment', 'underscore', 'eteration/eteration', 'eteration/ui/base-viewmodel', 'eteration/eteration-ajax', 'eteration/ui/login-viewmodel', 'eteration/widgets/ui-wingosharebox', 'ui-helper/storage-helper', 'ui-helper/cookie-helper', 'ajaxConsolidator', 'promotion-helper' ],

function($, ko, moment, underscore, Eteration, BaseViewModel, etrAjax, loginView, WingoShareBoxWidget, storageHelper, cookieHelper, ajaxConsolidator, promoHelper) {

    function WingoViewModel() {
        var self = this;
        ko.utils.extend(self, new BaseViewModel.BaseViewModel());
        self.promotionHelper= promoHelper.getInstance();
        self.isTurkish = ko.observable(self.language() == 'tr');

        self.smartTargetPromotionsConsumed = false;
        self.showDcpPromotions = true;
        self.showCityArea = ko.observable(false);

        self.triggerUrlManipulation =false;
        self.urlManipulationDone =false;        
       
        self.themeList = ko.observableArray([]);
        self.responseCityList = ko.observableArray([]);
        self.responseSelectedCity = ko.observable('');
        self.responseSelectedCity.name='';
        self.responseSelectedCity.code='';
        
        self.defaultCityCode = null;
        var url = null;
        self.initialUrl =null;
        self.comingFromUrl = ko.observable(false)
        self.indexOfPromotionsOrDestinations = 0;
        var incrementBy = 5;

        var urlSourcesLoaded =false;
        self.themeState = ko.observable(false);

        self.originalStQueryResponse; 
        self.noResultFoundForDestination = ko.observable(false);
        var countryDefaultCityPairs = [];
        var regionDefaultCityPairs = [];
        self.urlSelectedThemeOptions =[];//kontrol
        var themeListLoaded=false;
        
        var wywFromInfo = {
      		  portCode: "",
      		  cityCode: ""
	      };
	      
	      var wywToInfo = {
	    		  portCode: "",
	    		  cityCode: ""
	    };
      
	      self.setWywFromInfo = function (portCode, cityCode){
	    	  wywFromInfo.portCode=portCode;
	    	  wywFromInfo.cityCode=cityCode;
	      }
	      
	      self.setWywToInfo = function (portCode, cityCode){
	    	  wywToInfo.portCode=portCode;
	    	  wywToInfo.cityCode=cityCode;
              scrollToWingoCountainer();
	      }
        
	      self.getWywFromInfo= function(){
	    	  return wywFromInfo;
	      }
	      self.getWywToInfo= function(){
	    	  return wywToInfo;
	      }
        function showClearButtonFn () {
            if (self.promotionHelper.visaRequirement || self.promotionHelper.selectedThemeOptions().length > 0) {
                $('.btn-wywFilter-clear').removeAttr('disabled');
            } else {
                $('.btn-wywFilter-clear').attr('disabled', true);
                scrollToWingoCountainer();
            }
        }


        self.loadMoreDestinations = ko.observable(true);
        
        function scrollToWingoCountainer(el,animTime){
        	
        	var body=$("html, body");
        	var elm;
        	if(el){
        		elm=el;
        	}else{
        		elm= $("html, body");
        	}
        	if(!animTime){
        		animTime=200;
        	}
        	body.stop().animate({
                scrollTop : (elm.offset().top - 170)
            }, animTime);
        }
        
        self.setDefaultSortPreference = function() {
            $(".btn-intelligent").addClass("active");
            $(".btn-price-asc").removeClass("active");
            $(".btn-price-desc").removeClass("active");
            self.promotionHelper.selectedSortPreference = self.promotionHelper.initialSortPreference();

        };

        function contains (dataset, item) {
            for (var i = 0; i < dataset.length; i++) {
                if (item == dataset[i]) {
                    return true;
                }
            }
            return false;
        }
        
        self.updateSelectedThemeOptions = function(theme) {
            if (contains(self.promotionHelper.selectedThemeOptions(), theme)) {   
            	self.promotionHelper.selectedThemeOptions.remove(theme);
            	$(event.target).closest('.badge').removeClass("active"); 
            } else {
                self.promotionHelper.selectedThemeOptions.push(theme);
                $(event.target).closest('.badge').addClass("active");
            }
            showClearButtonFn()
        };

        function clearVisa () {
            self.promotionHelper.visaRequirement=0;
            showClearButtonFn();
            if ($(".btn-visa").hasClass("active")) {
                $("#btn-loadmore, #btn-loadmore-mobile").removeClass('hide');
                $(".btn-visa").removeClass("active");
            }
            if ($(".btn-nonvisa").hasClass("active")) {
                $("#btn-loadmore, #btn-loadmore-mobile").removeClass('hide');
                $(".btn-nonvisa").removeClass("active");
            }
        }

        self.filterVisa = function() {
            if ($(".btn-visa").hasClass("active")) {
                $("#btn-loadmore, #btn-loadmore-mobile").removeClass('hide');
                $(".btn-visa").removeClass("active");
                self.promotionHelper.visaRequirement=0;
                showClearButtonFn();

            } else {
                $("#btn-loadmore, #btn-loadmore-mobile").removeClass('hide');
                $(".btn-visa").addClass("active");
                $(".btn-nonvisa").removeClass("active");
                self.promotionHelper.visaRequirement=1;
                showClearButtonFn();
            }
        };

        self.filterNonVisa = function() {
            if ($(".btn-nonvisa").hasClass("active")) {
                $("#btn-loadmore, #btn-loadmore-mobile").removeClass('hide');
                $(".btn-nonvisa").removeClass("active");
                self.promotionHelper.visaRequirement=0;
                showClearButtonFn();
            } else {
                $("#btn-loadmore, #btn-loadmore-mobile").removeClass('hide');
                $(".btn-nonvisa").addClass("active");
                $(".btn-visa").removeClass("active");
                self.promotionHelper.visaRequirement=-1;
                showClearButtonFn();
            }
        };

        self.filterScoreDescending = function() {
            $("#btn-loadmore, #btn-loadmore-mobile").removeClass('hide');
            $(".btn-intelligent").addClass("active");
            $(".btn-price-asc").removeClass("active");
            $(".btn-price-desc").removeClass("active");

            var sortItem = {};

            sortItem.sortBy = "promotionscore";
            sortItem.sortDirection = "descending";
            self.promotionHelper.selectedSortPreference = sortItem;

            self.handleFilterMechanism();

        }

        self.filterPriceAscending = function() {
            $("#btn-loadmore, #btn-loadmore-mobile").removeClass('hide');
            $(".btn-intelligent").removeClass("active");
            $(".btn-price-asc").addClass("active");
            $(".btn-price-desc").removeClass("active");

            var sortItem = {};

            sortItem.sortBy = "price";
            sortItem.sortDirection = "ascending";
            self.promotionHelper.selectedSortPreference = sortItem;

            self.handleFilterMechanism(true, false);
        }

        self.filterPriceDescending = function() {
            $(".btn-intelligent").removeClass("active");
            $(".btn-price-asc").removeClass("active");
            $(".btn-price-desc").addClass("active");

            var sortItem = {};

            sortItem.sortBy = "price";
            sortItem.sortDirection = "descending";
            self.promotionHelper.selectedSortPreference = sortItem;

            self.handleFilterMechanism(true, false);
        }

        function clearUrlString(){
        	var urlString ="";
            if( self.comingFromUrl()){
            	urlString +="?"+ url;
            }else{
            	urlString =self.initialUrl;
            }
            window.history.pushState("string", "Title", urlString);
        }
        
       function createUrlStringFromParameters (){
        	var urlString="?";
        	if(self.promotionHelper.fromCountryArray.length>0){
        		urlString +="dC=";
        		for(var i=0; i<self.promotionHelper.fromCountryArray.length; i++){
            		urlString+=self.promotionHelper.fromCountryArray[i]+"-";
        		}
        		urlString = urlString.substring(0, urlString.length -1 );
        		urlString +="&";
        	}
        	if(self.promotionHelper.toCountryArray.length>0){
        		urlString +="aC=";
        		for(i=0; i<self.promotionHelper.toCountryArray.length; i++){
            		urlString+=self.promotionHelper.toCountryArray[i]+"-";
        		}
        		urlString = urlString.substring(0, urlString.length -1 );
        		urlString +="&";
        	}
        	if(self.promotionHelper.fromRegionArray.length>0){
        		urlString +="dR=";
        		for(i=0; i<self.promotionHelper.fromRegionArray.length; i++){
            		urlString+=self.promotionHelper.fromRegionArray[i]+"-";
        		}
        		urlString = urlString.substring(0, urlString.length -1 );
        		urlString +="&";
        	}
        	if(self.promotionHelper.toRegionArray.length>0){
        		urlString +="aR=";
        		for(i=0; i<self.promotionHelper.toRegionArray.length; i++){
            		urlString+=self.promotionHelper.toRegionArray[i]+"-";
        		}
        		urlString = urlString.substring(0, urlString.length -1 );
        		urlString +="&";
        	}
        	
        	if(self.promotionHelper.fromCityArray.length>0){
        		urlString +="dCt=";
        		for( i=0; i<self.promotionHelper.fromCityArray.length; i++){
            		urlString+=self.promotionHelper.fromCityArray[i]+"-";
        		}
        		urlString = urlString.substring(0, urlString.length -1 );
        		urlString +="&";
        	}
        	if(self.promotionHelper.toCityArray.length>0){
        		urlString +="aCt=";
        		for(i=0; i<self.promotionHelper.toCityArray.length; i++){
            		urlString+=self.promotionHelper.toCityArray[i]+"-";
        		}
        		urlString = urlString.substring(0, urlString.length -1 );
        		urlString +="&";
        	}
        	if(self.promotionHelper.fromPortArray.length>0){
        		urlString +="dP=";
        		for(i=0; i<self.promotionHelper.fromPortArray.length; i++){
            		urlString+=self.promotionHelper.fromPortArray[i]+"-";
        		}
        		urlString = urlString.substring(0, urlString.length -1 );
        		urlString +="&";
        	}
        	if(self.promotionHelper.toPortArray.length>0){
        		urlString +="aP=";
        		for(i=0; i<self.promotionHelper.toPortArray.length; i++){
            		urlString+=self.promotionHelper.toPortArray[i]+"-";
        		}
        		urlString = urlString.substring(0, urlString.length -1 );
        		urlString +="&";
        	}
        	
        	if(self.promotionHelper.visaRequirement!=0){
        		urlString +="v=";
        		if(self.promotionHelper.visaRequirement==1){
        			urlString +="yes";
        		} else{
        			urlString +="no";
        		}
        		urlString +="&";
        	}
        	if(self.promotionHelper.selectedThemeOptions().length>0){
        		urlString +="t=";
        		for(i=0; i<self.promotionHelper.selectedThemeOptions().length; i++){
            		urlString+=self.promotionHelper.selectedThemeOptions()[i]+"-";
        		}
        		urlString = urlString.substring(0, urlString.length -1 );
        		urlString +="&";
        	}
        	
        	urlString = urlString.substring(0, urlString.length -1 );
        	console.info("url string is: "+urlString);
        	window.history.pushState("string", "Title", urlString);
        }
        
        function parseUrlAndCreateQueryParameters () {
            var bigChunks = url.split('&');
            var i;
            var t;
            var p;
            var codes;
            var foundUrlParameters = false;
            for (i = 0; i < bigChunks.length; i++) {
                var pair = bigChunks[i].split('=');
                var indicator = pair[0];
                codes = pair[1].split('-');
                if (indicator == 'dC') {
                    // get country names and defult city-->def city for first
                    // country
                    foundUrlParameters = true;
                    if (typeof countryDefaultCityPairs != 'undefined') {
                        for (t = 0; t < codes.length; t++) {
                            self.promotionHelper.fromCountryArray.push(countryDefaultCityPairs[codes[t]].countryName);
                            // getdefault city
                            if (t == 0) {
                                self.defaultCityCode = countryDefaultCityPairs[codes[t]].defaultCityCode;
                            }
                        }
                    }
                } else if (indicator == 'aC') {
                    foundUrlParameters = true;
                    if (typeof countryDefaultCityPairs != 'undefined') {
                        for (t = 0; t < codes.length; t++) {
                            self.promotionHelper.toCountryArray.push(countryDefaultCityPairs[codes[t]].countryName);
                        }
                    }
                } else if (indicator == 'dR') {
                    foundUrlParameters = true;
                    if (typeof regionDefaultCityPairs != 'undefined') {
                        for (t = 0; t < codes.length; t++) {
                            self.promotionHelper.fromRegionArray.push(regionDefaultCityPairs[codes[t]].regionName);
                            var defCountryCode = regionDefaultCityPairs[codes[t]].defaultCountryCode;
                            self.defaultCityCode = countryDefaultCityPairs[defCountryCode].defaultCityCode;
                        }
                    }
                } else if (indicator == 'aR') {
                    foundUrlParameters = true;
                    if (typeof regionDefaultCityPairs != 'undefined') {
                        for (t = 0; t < codes.length; t++) {
                            self.promotionHelper.toRegionArray.push(regionDefaultCityPairs[codes[t]].regionName);

                        }
                    }
                } else if (indicator == 'dCt') {
                    foundUrlParameters = true;
                    for (t = 0; t < codes.length; t++) {
                        self.promotionHelper.fromCityArray.push(codes[t]);
                        if (t == 0) {
                            self.defaultCityCode = codes[t];
                        }
                    }
                } else if (indicator == 'aCt') {
                    foundUrlParameters = true;
                    for (t = 0; t < codes.length; t++) {
                        self.promotionHelper.toCityArray.push(codes[t]);
                    }
                }

                else if (indicator == 'dP') {
                    foundUrlParameters = true;
                    for (t = 0; t < codes.length; t++) {
                        self.promotionHelper.fromPortArray.push(codes[t]);
                    }
                } else if (indicator == 'aP') {
                    foundUrlParameters = true;
                    for (t = 0; t < codes.length; t++) {
                        self.promotionHelper.toPortArray.push(codes[t]);
                    }
                } else if (indicator == 'c') {
                    // c-->cabin Class
                    foundUrlParameters = true;
                    for (t = 0; t < codes.length; t++) {
                        if (codes[t] == "eco")
                            self.promotionHelper.cabinClass.push("Economy");
                        else if (codes[t] = "bus") {
                            self.promotionHelper.cabinClass.push("Business");
                        }
                    }
                }  else if (indicator == 'v') {
                    // c-->visa
                    foundUrlParameters = true;
                    for (t = 0; t < codes.length; t++) {
                        if (codes[t] == "yes")
                            self.promotionHelper.visaRequirement=1;
                        else if (codes[t] == "no") {
                            self.promotionHelper.visaRequirement=-1;
                        }else{
                        	self.promotionHelper.visaRequirement=0;
                        }
                    }
                } else if (indicator == 't') {
                    // t-->theme
                    // t=history-food => history veya food
                    // t=(history-food) => hem history hem food
                    foundUrlParameters = true;
                    if (pair[1].indexOf("(") == 0 && pair[1].indexOf(")") == pair[1].length - 1) {
                        codes = (pair[1].substring(1, pair[1].length - 1)).split('-');
                        for (t = 0; t < codes.length; t++) {
                        	codes[t]=codes[t].replace(/%20/g, ' ');
                            for (p = 0; p < self.themeList().length; p++) {
                                if (codes[t] == self.themeList()[p].id) {
                                    self.promotionHelper.urlSelectedAndThemeOptions.push(self.themeList()[p].id);
                                }
                            }
                        }
                    } else {
                        for (t = 0; t < codes.length; t++) {
                        	codes[t]=codes[t].replace(/%20/g, ' ');
                            for (p = 0; p < self.themeList().length; p++) {
                                if (codes[t] == self.themeList()[p].id) {
                                    self.urlSelectedThemeOptions.push(self.themeList()[p].id);
                                    self.promotionHelper.selectedThemeOptions.push(self.themeList()[p].id);
                                }
                            }
                        }
                    }
                }
            }

            if (!foundUrlParameters) {
                self.comingFromUrl(false);
                self.smartTargetOperationsStart();
                return;

            }
            createCityComboAndSetDefaultCity();
        }

        
        function getNeededDefaultPairs () {
            etrAjax.get({
                app : 'app.ibs',
                disableLoader : true,
                service : '/parameters/citycountryandcountryregionpairs',

                callback : function(response) {
                    if (response.data != null && response.data != undefined && response.data.length==2) {
                        countryDefaultCityPairs = response.data[0];
                        regionDefaultCityPairs = response.data[1];
                        urlSourcesLoaded=true;
                        parseUrlAndCreateQueryParameters();
                     
                    } else {
                        self.reloadPage();
                    }
                }
            });
        }

        function setParametersFromUrl() {
            if (!urlSourcesLoaded) {
                getNeededDefaultPairs();
            } else {
                parseUrlAndCreateQueryParameters();
            }
        }
        
        function processSmartTargetFilteringResults(response){
        	
            self.smartTargetPromotionsConsumed=true;
            self.promotionHelper.populateWingoDataUsingResponse(response);
            self.processPromotionsOrDestinations();
        }

        
        function handleSmartTargetQueryResponse  (){
        	var response = self.originalStQueryResponse;
        	   handleFromInfoRelatedWork((self.comingFromUrl())?self.responseSelectedCity().code:wywFromInfo.portCode);
        	   handleToInfoRelatedWork(wywToInfo.portCode);

                if(!response||!response.data){
                    response =  {"data":{"components" : []}};
                }

	            self.promotionHelper.applyFiltersToSmartTargetQueryResults(response.data.components, function(newComp) {
	            	response.data.components = newComp;
	            	processSmartTargetFilteringResults(response);
	            });
        }

        
        self.smartTargetOperationsStart = function(byPassStQueryCall, showStResults) {
           
            self.promotionHelper.globalDestinationList[wywFromInfo.cityCode] = wywFromInfo.cityCode;
            
            showStResults = (showStResults !== false);

            if(!byPassStQueryCall || byPassStQueryCall != true){
                etrAjax.post({
                    app : 'app.cms',
                    disableLoader : true,
                    disableErrorHandling : true,
                    service : '/content/stqueryforpromotions',
                    data : {
						"language": i18n.getUserLocale(), 
						"country": i18n.getUserCountry(),
                        "region" : "Where we fly - Destination Results",
                        "template" : "Promotion",
                        "maxItems" : 100,
                        "includeMetadata" : true

                    },
                    callback : function(response) {                       
                        self.originalStQueryResponse=response;
                        handleSmartTargetQueryResponse();
                    }
                });
            }else if (showStResults) {
                etrAjax.startLoading(false,false, true);
                handleSmartTargetQueryResponse();
            }
           
        }

        self.wingoOperationsStart = function() {
            if (!themeListLoaded) {
                getThemeList();
            }
            
            prepareParametersForNewRoundOfPromotions();
            
            if (self.comingFromUrl()) {
            	url = window.location.href;
                url = url.substring(url.indexOf("?") + 1);
                setParametersFromUrl();
            } else {
                self.smartTargetOperationsStart();
            }
        };

        
        self.flightmapcampaignpromotion = function(componentIdList) {
            etrAjax.post({
                app : 'app.cms',
                disableLoader : true,
                disableErrorHandling : true,
                service : '/content/dcpqueryfordestination',
                data : {
						"language": i18n.getUserLocale(), 
						"country": i18n.getUserCountry(),
                    "schema" : "Destination",
                    "template" : "Destination (Wingo layout)",
                    "componentList" : componentIdList,
                    "maxItems" : 100,
                    "includeMetadata" : true
                },
                callback : function(response) {
                    self.promotionHelper.populateWingoDataUsingResponse(response);
                }
            });
        };
        
        function getThemeList () {
            var publicationID = $('meta[name=PublicationID]').attr("content");
            etrAjax.get({
                app : 'app.cms',
                service : '/content/queryofcategories',
                disableLoader : true,
                disableErrorHandling : true,
                data : {
                    "publicationId" : publicationID,
                    "title" : "Destination Tags "
                },
                callback : function(response) {
                    themeListLoaded=true;
                    if (!response.data || response.data.length == 0)
                        return;

                    else{
                        self.themeList(response.data);
                    }
                }
            });
        };

        function createCityComboAndSetDefaultCity () {

            var queryObject = self.promotionHelper.createQueryDataForPromotions();
            etrAjax.post({
                app : 'app.cms',
                service : '/content/getcitylist/'+self.defaultCityCode+'/'+wywFromInfo.portCode,
                disableLoader : true,
                disableErrorHandling : true,
                data : queryObject,
                callback : function(response) {
                    if (!response.data || !response.data.cities || response.data.cities.length == 0) {
                        self.reloadPage();
                    } else {
                    	self.responseCityList(response.data.cities);
                    	self.responseSelectedCity(response.data.selectedCity);
                        storageHelper.setItem({
                            key: "ORIGIN_PORT_CODE",
                            value: self.responseSelectedCity().code,
                            webStorageType: storageHelper.Stores.SESSION_STORAGE
                        });

                        setTimeout(self.showCityArea(true), 200);

                        self.showDcpPromotions=true;
                        self.smartTargetOperationsStart();
                    }
                }
            });
        }


        function fillSelectedThemeOptionsByUrl() {
            for (var i = 0; i < self.urlSelectedThemeOptions.length; i++) {
                self.promotionHelper.selectedThemeOptions.push(self.urlSelectedThemeOptions[i]);
            }
        }

        self.departureCityChanged = function(selectedCity) {
            setTimeout(function() {
                $('#cityListArea .dropdown .dropdown-menu li a').dropdown('toggle');
                $("#btn-loadmore, #btn-loadmore-mobile").removeClass('hide');
            }, 200);
            clearFromParameters();
            self.responseSelectedCity(selectedCity);
            storageHelper.setItem({
                key: "ORIGIN_PORT_CODE",
                value: self.responseSelectedCity().code,
                webStorageType: storageHelper.Stores.SESSION_STORAGE
            });
            self.promotionHelper.fromPortArray.push(self.responseSelectedCity().code);
            self.showDcpPromotions=true;
            self.clearFilters();
            fillSelectedThemeOptionsByUrl();
            prepareParametersForNewRoundOfPromotions();
            self.loadMoreDestinations(true);
            createUrlStringFromParameters();
            self.smartTargetOperationsStart();
        }
        
        function handleToInfoRelatedWork(cityOrPortCode, isCityCode){
        	if (typeof cityOrPortCode !== "undefined"  && cityOrPortCode != "") {
            	self.promotionHelper.toPortArray = [];
        		isCityCode && isCityCode == true ?self.promotionHelper.toCityArray.push(cityOrPortCode) :self.promotionHelper.toPortArray.push(cityOrPortCode);
        		prepareParametersForNewRoundOfPromotions();
                self.loadMoreDestinations(false);
                checkForUrlManipulation();
            }
        }
        
        function handleFromInfoRelatedWork(portCode){
        	if(typeof portCode !== "undefined"  && portCode != "" ){

	        	self.promotionHelper.fromPortArray = [];
	            self.promotionHelper.fromPortArray.push(portCode);
        	}
        }
        
        function checkForUrlManipulation(){
        	 if(self.triggerUrlManipulation && !self.urlManipulationDone){
 		   		createUrlStringFromParameters();
 		   		self.urlManipulationDone=true;
 		   	}
        }
        
        function setQueryObjectPaginationInfo(queryObject){
        	if(wywToInfo.portCode==""){
        	 queryObject.startIndex = self.indexOfPromotionsOrDestinations;
             queryObject.pageSize = incrementBy;        		
        	}
        }

        function setQueryObjectCityCodeFrom(queryObject){
            if(wywFromInfo.cityCode!=""){
                addQueryObjectCmsQuery(queryObject,{"SortByCityCode":wywFromInfo.cityCode});
            }
        }

        function addQueryObjectCmsQuery(queryObject,data){
            if(!queryObject.cmsQuery){
                queryObject.cmsQuery=[];
            }
            queryObject.cmsQuery.push(data);
        }

        self.processPromotionsOrDestinations = function() {
            if (self.smartTargetPromotionsConsumed) {
                if (self.showDcpPromotions) {
                    processPromotions();
                } else {
                    processDestinations();
                }
            }
        }

        function processDestinations () {
        	$( document ).trigger( "addWingoLoder");
        	handleToInfoRelatedWork(wywToInfo.cityCode, true);

            var queryObject = self.promotionHelper.createQueryDataForDestinations();
        	setQueryObjectPaginationInfo(queryObject);
            setQueryObjectCityCodeFrom(queryObject);
            etrAjax.post({
                app : 'app.cms',
                service : '/content/destinations',
                disableLoader : true,
                disableErrorHandling : true,
                data : queryObject,
                async : false,
                callback : function(response) {
                	$( document ).trigger( "removeWingoLoder");
                    if (!response.data || !response.data.components || response.data.components.length == 0) {
                         if (self.promotionHelper.processedWingoItems().length<=0) {
                             self.noResultFoundForDestination(true);
                         }
                        self.loadMoreDestinations(false);
                    } else {
                        self.indexOfPromotionsOrDestinations += incrementBy;
                        self.promotionHelper.filterRecurringDestinations(response.data.components, false, function(newComponents) {
                            self.promotionHelper.filterByVisaRequirement(newComponents, function(newComponents2) {
                                response.data.components = newComponents2;
                                if (response.data.components.length == 0) {
                                    processDestinations();
                                } else {
                                    self.promotionHelper.populateWingoDataUsingResponse(response);
                                }
                            });
                        });
                    }
                }
            });

        }


        function processPromotions () {
        	$( document ).trigger( "addWingoLoder");
            clearFromParameters();
            if(wywFromInfo.portCode==""){
            	prepareForSwitchingToDestinations();
            	return;
            }
            handleFromInfoRelatedWork((self.comingFromUrl())?self.responseSelectedCity().code:wywFromInfo.portCode);
            handleToInfoRelatedWork(wywToInfo.portCode);        
            
            var queryObject = self.promotionHelper.createQueryDataForPromotions();
            setQueryObjectPaginationInfo(queryObject);

            checkForUrlManipulation();
            
            etrAjax.post({
                app : 'app.cms',
                service : '/content/query',
                disableLoader : true,
                async : false,
                disableErrorHandling : true,
                data : queryObject,
                callback : function(response) {
                	$( document ).trigger( "removeWingoLoder");
                    if (!response.data || !response.data.components || response.data.components.length == 0) {
                    	prepareForSwitchingToDestinations();
                    } else {
                        self.indexOfPromotionsOrDestinations += incrementBy;
                        self.promotionHelper.filterRecurringDestinations(response.data.components, true, function(newComponents) {
                        	self.promotionHelper.filterByVisaRequirement(newComponents, function(newComponents2) {
                                response.data.components = newComponents2;
                                if (response.data.components.length == 0 ) {
                                    processPromotions();
                                } else {
                                    self.promotionHelper.populateWingoDataUsingResponse(response);
                                }
                            });
                        });
                    }
                }
            });
        }

        self.clearToParameters = function() {
            self.promotionHelper.toCountryArray = [];
            self.promotionHelper.toRegionArray = [];
            self.promotionHelper.toCityArray = [];
            self.promotionHelper.toPortArray = [];
        }
        function clearFromParameters () {
            self.promotionHelper.fromCountryArray = [];
            self.promotionHelper.fromRegionArray = [];
            self.promotionHelper.fromCityArray = [];
            self.promotionHelper.fromPortArray = [];
        }
        
        function prepareParametersForNewRoundOfPromotions(){
        	 self.indexOfPromotionsOrDestinations = 0;
             self.promotionHelper.clearWingoParams();
        }
        
        function prepareForSwitchingToDestinations(){
        	self.showDcpPromotions=false;
            self.indexOfPromotionsOrDestinations = 0;
            self.processPromotionsOrDestinations();
        }

        self.clearFilters= function() {
            $("#btn-loadmore, #btn-loadmore-mobile").removeClass('hide');
            if(!(self.comingFromUrl() && (self.initialUrl.indexOf("v=yes")>-1 ||self.initialUrl.indexOf("v=no")>-1))){
                clearVisa();            	
            }
            self.promotionHelper.selectedThemeOptions([]);
            scrollToWingoCountainer(undefined,undefined);
        }

        self.clearAllFilters = function() {
            clearFromParameters();
            if (self.comingFromUrl()) {
                var tempSelectedCityCopy = self.responseSelectedCity();
                self.responseSelectedCity("");
                self.responseSelectedCity(tempSelectedCityCopy);
                self.promotionHelper.fromCityArray.push(self.responseSelectedCity().code);
            }
           
            $('.wyw-filter-menu .badge').removeClass('active');
            self.clearFilters();
            self.loadMoreDestinations(true);
            prepareParametersForNewRoundOfPromotions();
            self.showDcpPromotions=true;
            clearUrlString();
            self.smartTargetOperationsStart(true, true);
            showClearButtonFn();
            self.processPromotionsOrDestinations();
        }

        self.handleFilterMechanismFront= function(){
        	self.handleFilterMechanism(true, true)
        }
        self.handleFilterMechanism = function(byPassStQueryCall, showStResults) {
            $("#btn-loadmore, #btn-loadmore-mobile").removeClass('hide');
            self.loadMoreDestinations(true);
            self.showDcpPromotions=true;
            prepareParametersForNewRoundOfPromotions();
            createUrlStringFromParameters();
            byPassStQueryCall = (byPassStQueryCall === true);
            etrAjax.startLoading();
            //pyPass new call, use original stquery result ; expected to give the same result as first call
            self.smartTargetOperationsStart(byPassStQueryCall, showStResults);

            if ($(window).width() < 992) {
                $(".wyw-filter").click();
            }
            scrollToWingoCountainer(undefined,undefined);
            self.processPromotionsOrDestinations();
            etrAjax.stopLoading();
        }

        self.reloadPage = function() {
            if (typeof flightmapLinks != 'undefined' && flightmapLinks.flightmap) {
                self.promotionHelper.redirectTo(flightmapLinks.flightmap);
            } else if (typeof wingoblockLinks != 'undefined' && wingoblockLinks.flightmap) {
                self.promotionHelper.redirectTo(wingoblockLinks.flightmap)
            }
        }

   

        if (window.location.href.indexOf("?map=true") > -1) {
            // sayfanın reload olup olmadığını kontrol ediyor
            if (performance.navigation.type == 1) {
                storageHelper.removeItem({ key: "DESTINATION_CITY_CODE", webStorageType: storageHelper.Stores.SESSION_STORAGE });
                var windowLocation = window.location.href
                var windowLocationSlice = windowLocation.slice(0, -9);
                window.location.href = windowLocationSlice;
            }
        }

        $(".wyw-filter").on("click", function() {
            if ($(this).parents(".wyw-filter-wrapper").hasClass("wyw-filter-active")) {
                
            	$(this).parents(".wyw-filter-wrapper").removeClass("wyw-filter-active");
            	$(this).parents(".wyw-filter-menu").removeAttr("style");
            	$('body').removeClass('modal-open');
                setTimeout(function() {
                    $(".wyw-filter").removeAttr('style');
                    $('.wyw-filter span').text(i18n.get("Label-OB-206.mobil"));
                    $('.wyw-filter i').removeClass('fa-close');
                    $('.wyw-filter i').addClass('fa-filter');
                }, 500);
                $(".wyw-filter-menu .mobile-filter").removeAttr('style');
            } else {
            	$(this).parents(".wyw-filter-wrapper").addClass("wyw-filter-active");
            	$('body').addClass('modal-open');
            	 if(window.isPhoneOrTablet){
                	$(this).parents(".wyw-filter-menu").css({"top": 0,"z-index":1053});
                }
                setTimeout(function() {
                    $(".wyw-filter-active .wyw-filter").css({
                        background : '#676767',
                        border : '1px solid #676767',
                    });
                    $('.wyw-filter span').text(i18n.get("Link-OB-28"));
                    $('.wyw-filter i').removeClass('fa-filter');
                    $('.wyw-filter i').addClass('fa-close');
                    $('.wyw-filter-menu .mobile-filter').css({
                        display : 'block'
                    });
                }, 500);
            }
        });
        
        // Force page scroll position to top at page refresh
        window.onbeforeunload = function () {
        	window.scrollTo(0, 0);
        };

    }

    return {
        ViewModel : WingoViewModel
    };
});